import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { base, formatTimeToAMPM } from "../../constants/base";
import { requestStatus, rescheduleRequest } from "../../redux/actions/request";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ChatRoute from "../Notification/Childs/ChatRoute";
import Info from "../Notification/Childs/Info";
import Feedback from "../Notification/Childs/Feedback";

const RequestModal = () => {
  const notificaion = useSelector((state) => state.notificaions.notification);
  const auth = useSelector((state) => state.AuthSlice.user);
  const [showFeilds, setShowFields] = useState("");
  const dispatch = useDispatch();
  const [reason, setReason] = useState("");
  const [schedule, setSchedule] = useState(null);

  const user = useSelector((state) => state.AuthSlice.user);

  const handleRequestStatus = async (id, status, userId) => {
    const data = {
      id: id,
      status: status,
      reason: reason,
      user_id: userId,
    };

    const response = await dispatch(requestStatus(data));
    setShowFields("");
  };

  const handleRescheduleRequest = async (id, status) => {
    if (!schedule) {
      toast.error("Please select time first.");
      return;
    }

    if (reason.trim().length < 1) {
      toast.error("Please write the reason of reschedule.");
      return;
    }

    const data = {
      id: id,
      status: status,
      reason: reason,
      schedule_id: schedule,
    };

    const response = await dispatch(rescheduleRequest(data));
    setShowFields("");
    if (rescheduleRequest.fulfilled(response)) {
      toast.success("Request for reschedule has been sent.");
    } else toast.error("Sorry, this action is not performed.");
  };
  return (
    <div
      className="modal fade"
      id="employe-model"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel"
      tabindex="-1"
    >
      <div className="modal-dialog modal-dialog-centered service-add-model model-width-control">
        {!notificaion.loading && (
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                id="close-model-btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div className="modal-body">
              <div className="model-detail-box">
                <Info notificaion={notificaion} />
                <br />
                {/* Pending  */}
                {notificaion?.data?.request?.status === "Pending" ? (
                  <div className="model-buttons-box">
                    <button
                      className="category-box title-box-text me-2"
                      onClick={() => {
                        handleRequestStatus(
                          notificaion?.data?.request?.id,
                          "Accepted",
                          notificaion?.data?.user_id
                        );
                      }}
                      data-bs-dismiss="modal"
                    >
                      Accept
                    </button>

                    <span
                      className="category-box title-box-text me-2"
                      onClick={() => setShowFields("decline")}
                    >
                      Decline
                    </span>

                    <span
                      className="category-box title-box-text"
                      onClick={() => setShowFields("re-schedule")}
                    >
                      Re schedule
                    </span>
                  </div>
                ) : notificaion?.data?.request?.status == "Accepted" ? (
                  <div className="model-buttons-box" data-bs-dismiss="modal">
                    <ChatRoute role={user?.role?.name} />
                  </div>
                ) : // Reschedule
                notificaion?.data?.request?.status == "Reschedule" ? (
                  notificaion?.data?.request?.customer_id === auth.id ? (
                    <div className="model-buttons-box">
                      <button
                        className="category-box title-box-text me-2"
                        onClick={() => {
                          if (auth.role.name === "corporate") {
                            handleRequestStatus(
                              notificaion?.data?.request?.id,
                              "Accepted",
                              notificaion?.data?.request?.customer_id
                            );
                          } else {
                            handleRequestStatus(
                              notificaion?.data?.request?.id,
                              "Accepted",
                              notificaion?.data?.request?.customer_id
                            );
                          }
                        }}
                        data-bs-dismiss="modal"
                      >
                        Accept
                      </button>

                      <span
                        className="category-box title-box-text accept-button-box"
                        style={{ cursor: "pointer" }}
                        data-bs-dismiss="modal"
                        onClick={() => {
                          handleRequestStatus(
                            notificaion?.data?.request?.id,
                            "Rejected",
                            notificaion?.data?.user_id
                          );
                        }}
                      >
                        Decline
                      </span>
                    </div>
                  ) : (
                    <div className="success-msg-text">
                      <span>
                        Your request for reschedule has been sent!{" "}
                        <i className="fa-regular fa-paper-plane"></i>
                      </span>
                    </div>
                  )
                ) : notificaion?.data?.request?.status == "Rejected" ? (
                  <div className="error-msg-text">
                    <span>
                      Your request has been cancelled{" "}
                      <i className="fa-solid fa-ban"></i>
                    </span>
                  </div>
                ) : (
                  // <div className="success-msg-text">
                  //   <span>
                  //     Job has been finished! <i className="fa-solid fa-check"></i>
                  //   </span>
                  // </div>

                  <Feedback feedback={notificaion?.data?.request?.feedback} />
                )}

                {/* Forms  */}
                {showFeilds === "re-schedule" ? (
                  <div>
                    <div>
                      {/* {notificaion?.data?.request &&
                        notificaion?.data?.request?.user?.schedules?.map(
                          (item, index) => (
                            <div
                              className="re-shdule-checkbox"
                              onClick={() => setSchedule(item?.id)}
                            >
                              <label
                                htmlFor={`schedule-${index}`}
                                className="shedule-label"
                              >
                                <input
                                  type="radio"
                                  name="re-shedule"
                                  id={`schedule-${index}`}
                                  className="shedule-checkbox"
                                />

                                <div className="shedule-box-main">
                                  <span>{item?.day}</span>
                                  <div className="shedule-timing-box">
                                    <span>{item?.start_time}</span>
                                    <p>To</p>
                                    <span>{item?.end_time}</span>
                                  </div>
                                </div>
                              </label>
                            </div>
                          )
                        )} */}

                      {notificaion?.data?.request &&
                        notificaion?.data?.request?.employee?.schedules?.map(
                          (item, index) => (
                            <div
                              className="re-shdule-checkbox"
                              onClick={() => setSchedule(item?.id)}
                            >
                              <label
                                htmlFor={`schedule-${index}`}
                                className="shedule-label"
                              >
                                <input
                                  type="radio"
                                  name="re-shedule"
                                  id={`schedule-${index}`}
                                  className="shedule-checkbox"
                                />

                                <div className="shedule-box-main">
                                  <span>{item?.day}</span>
                                  <div className="shedule-timing-box">
                                    <span>{item?.start_time}</span>
                                    <p>To</p>
                                    <span>{item?.end_time}</span>
                                  </div>
                                </div>
                              </label>
                            </div>
                          )
                        )}

                      <div className="custom-input-box about-company-textarea">
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          placeholder="Reason to Reschedule"
                          rows="3"
                          onChange={(e) => setReason(e.target.value)}
                        ></textarea>
                      </div>

                      <div className="d-flex justify-content-center mt-2">
                        <span
                          className="category-box title-box-text accept-button-box mt-3"
                          style={{ cursor: "pointer" }}
                          data-bs-dismiss="modal"
                          onClick={() =>
                            handleRescheduleRequest(
                              notificaion?.data?.request?.id,
                              "Reschedule"
                            )
                          }
                        >
                          Reschedule
                        </span>
                      </div>
                    </div>
                  </div>
                ) : showFeilds === "decline" ? (
                  <div>
                    <div className="custom-input-box about-company-textarea">
                      <textarea
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        placeholder="Reason to Decline"
                        rows="3"
                        onChange={(e) => setReason(e.target.value)}
                      ></textarea>
                    </div>

                    <div className="d-flex justify-content-center mt-2">
                      <span
                        className="category-box title-box-text accept-button-box mt-3"
                        style={{ cursor: "pointer" }}
                        data-bs-dismiss="modal"
                        onClick={() => {
                          handleRequestStatus(
                            notificaion?.data?.request?.id,
                            "Rejected",
                            notificaion?.data?.user_id
                          );
                        }}
                      >
                        Decline
                      </span>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestModal;
